import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from 'atoms/tooltip';


export default function Recommendation({ className, tooltipText, tooltipX, text, tooltipY, position }) {
  return (
    <span className={ className }>
      <Tooltip
        baseClassName={ `${className}__tooltip` }
        position={ position }
        space={ 0 }
        title={ tooltipText }
        tooltipX={ tooltipX }
        tooltipY={ tooltipY }
      >
        <div className={ `${className}__container` }>
          <i className={ `hundredicons-recomended-icon ${className}__background` } />
          <span className="background-star" />
        </div>
      </Tooltip>
      <span className={ `${className}__text` }>
        { text }
      </span>
    </span>
  );
}

Recommendation.defaultProps = {
  className: '',
  text: '',
  tooltipX: 50,
};

Recommendation.propTypes = {
  className: PropTypes.string,
  position: PropTypes.string.isRequired,
  text: PropTypes.string,
  tooltipText: PropTypes.string.isRequired,
  tooltipX: PropTypes.number,
  tooltipY: PropTypes.number.isRequired,
};
